import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {DocumentLiquidation} from '../../model/Entities/DocumentLiquidation';
import {DocumentLiquidationService} from '../../services/documentLiquidation.service';
import {SnackService} from '../../services/snack.service';
import {Document} from '../../model/Entities/Document';
import {Filter} from '../../model/Helpers/Filter';
import {DialogService} from '../../services/dialog.service';
import {Router} from '@angular/router';
import {
    DocumentConfirmDeleteLiquidationsDialogComponent
} from '../DocumentConfirmDeleteLiquidationsDialogComponent/document-confirm-delete-liquidations.dialog.component';
import {DOCUMENT_TYPE} from '../../model/Entities/DocumentType';

@Component({
    selector: 'document-liquidations-dialog',
    templateUrl: './document-liquidations.dialog.component.html',
    styleUrls: ['./document-liquidations.dialog.component.scss']
})
export class DocumentLiquidationsDialogComponent implements AfterViewInit {
    loading = true;
    changeTotalPaid: number = 0;
    documentLiquidation: DocumentLiquidation;
    readonly DOCUMENT_TYPE = DOCUMENT_TYPE;

    form = {
        amount: new FormControl('', [
            Validators.required,
        ]),
        entryDate: new FormControl('', [
            Validators.required,
        ]),
    };

    action: string;
    document: Document;
    documentLiquidations: DocumentLiquidation[];

    constructor(public dialog: MatDialogRef<DocumentLiquidationsDialogComponent>,
                private documentLiquidationService: DocumentLiquidationService,
                private snackService: SnackService,
                private router: Router,
                private dialogService: DialogService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.action = data.action;
        this.document = data.document;

        if (this.action === 'add') {
            this.documentLiquidation = new DocumentLiquidation();
            this.documentLiquidation.amount = Math.round(data.defaultAmount * 100) / 100; // 2 desetiny
            this.documentLiquidation.entryDate = new Date().toISOString().split("T")[0];
            this.documentLiquidation.document = data.document;
            this.loading = false;
        }

        if (this.action == 'list') {
            this.loadDocumentLiquidation();
        }
    }

    ngAfterViewInit(): void {

    }


    addLiquidations() {
        this.documentLiquidationService.save(this.documentLiquidation).subscribe((dl: DocumentLiquidation) => {
            this.snackService.showSuccess('Úhrada úspěšně zaznamenána');
            this.changeTotalPaid += dl.amount;
            this.dialog.close(this.changeTotalPaid);
        });
    }

    loadDocumentLiquidation()  {
        this.loading = true;
        this.documentLiquidationService.getSimpleList([
            new Filter('document_id', this.document.id)
        ], { 'expand': 'documents' }).subscribe((data: DocumentLiquidation[]) => {
            console.log(data);
            this.loading = false;
            this.documentLiquidations = data;
        });
    }

    deleteLiquidation(documentLiquidation: DocumentLiquidation) {

        this.dialogService.showDialog(DocumentConfirmDeleteLiquidationsDialogComponent, {
            'liquidation': documentLiquidation,
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.documentLiquidationService.delete(documentLiquidation.id).subscribe(() => {
                    this.snackService.showSuccess('Úhrada úspěšně smazána');
                    this.changeTotalPaid -= documentLiquidation.amount;
                    this.loadDocumentLiquidation();
                });
            }
        });
    }

    createReceivedPayment(liquidation: DocumentLiquidation) {
        this.dialog.close(0);
        this.router.navigate([`/documents/liquidation/${DOCUMENT_TYPE.RECEIVED_PAYMENT}/${liquidation.id}`]);
    }

    openReceivedPayment(liquidation: DocumentLiquidation) {
        this.dialog.close(0);
        window.open(`/documents/edit/${liquidation.documents[0].id}`, '_blank');
    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentLiquidationsDialogComponent/document-liquidations.dialog.component.ts